//GIFT PLUGIN
/*
//add gift codes and plugin status to shoptet administration -> VZHLAD A OBSAH - EDITOR - HTML KOD - PATICKA 
var giftPluginEnabled = true;
var giftMapping = {
  "Kod produktu ku ktoremu sa ziskava darcek": "Kod darceka",
  "Kod produktu ku ktoremu sa ziskava darcek": "Kod darceka"
};
*/
//if product code is in the mapping and the corresponding gift product is not in the cart - add gift product to cart
// debounceTimeout prevents rapid re-execution of code ensuring functions are executed only once and avoid addition multiple gifts for one product

function giftPlugin() {
  if (typeof giftMapping !== 'undefined' && giftMapping !== null && typeof giftPluginEnabled !== 'undefined' && giftPluginEnabled === true) {

    var debounceTimeout;
    const DEBOUNCE_DELAY = 300;
        
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      manageGiftsInCart(giftMapping);
      addGiftWarningCart();
    }, DEBOUNCE_DELAY);
  }
}

function manageGiftsInCart(giftMapping) {
  var cart = getShoptetDataLayer('cart');
  // add gift if exists product in cart
  for (var i = 0; i < cart.length; i++) {
    var productCode = cart[i].code;
    if (giftMapping.hasOwnProperty(productCode) && !isProductInCart(giftMapping[productCode])) {
      shoptet.cartShared.addToCart({productCode: giftMapping[productCode]}, true);
    }
  }

  /*
  // remove gift if not exist product in cart
  for (var productCode in giftMapping) {
    if (giftMapping.hasOwnProperty(productCode) && !isProductInCart(productCode)) {
      removeGiftFromCart(giftMapping[productCode]);
    }
  }
  */

  // check if product or gift is in the cart
  function isProductInCart(productCode) {
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].code === productCode) {
        return true;
      }
    }
    return false;
  }
  /*
  function removeGiftFromCart(giftCode) {
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].code === giftCode) {
        var itemId = cart[i].itemId;
        shoptet.cartShared.removeFromCart({itemId: itemId});
        break;
      }
    }
  }
  */
}

//TODO for products with variants - actually only for products without variants
//we will find the product code to which we are adding a gift and look for its value in related products so that we can later clone it from there
function showGiftBannerDetail(giftMapping) {
  if (typeof giftMapping !== 'undefined' && giftMapping !== null && typeof giftPluginEnabled !== 'undefined' && giftPluginEnabled === true) {

    var productCode = $('.p-detail-inner .p-code span:not(.default-variant):last').text().trim();
    var mappedValue = null;
      if (giftMapping.hasOwnProperty(productCode)) {
        //take text from administration of x+y plugin and clone it from xyDiscount__description element
        //gift must be assigned to all codes/variants for it to work properly
        var giftText = $('.xyDiscount__description p').html();
        if (giftText) {
          $('.p-detail-inner').before('<div class="top-banner-plugin-gift"><p>' + giftText + '</p></div>');
        }
        mappedValue = giftMapping[productCode];
        if (mappedValue !== null) {
          var relatedProducts = $('.products-related span[data-micro="sku"]');
          relatedProducts.each(function() {
            if ($(this).text() === mappedValue) {
              $(this).parents('.product').addClass('gift-in-related-products');
            }
          });
        }
      }

    if ($('.gift-in-related-products').length === 1 && $('.xyDiscount__banner').length === 1) {
      $('.gift-in-related-products').first().clone().prependTo('.type-detail .wm-gallery-box').addClass('banner-receives-gift');
      $('.banner-receives-gift').removeClass('product col-sm-6 col-md-12 col-lg-6 related-sm-screen-hide ');
      //clone icon from xyDiscount__banner, clone price from banner-receives gift and use it as final banner-receives-gift text
      $('i.xyDiscount__icon.icon-gift').clone().insertBefore('.banner-receives-gift .p');
      var giftPriceValue = $('.banner-receives-gift .price.price-final').text().trim();
      const numberRegexNew = /\d{1,3}(?:\s?\d{3})*(?:\.\d+)?/;
      var giftPriceMatch = giftPriceValue.match(numberRegexNew);
      if (giftPriceMatch) {
        var giftPrice = parseFloat(giftPriceMatch[0].replace(/\s/g, ''));
      }
      switch(lang) {
        case 'sk':
        $('<span class="gift-plugin-text"><strong>ZADARMO darček</strong> v hodnote ' + giftPrice + ' &euro;<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
        case 'hu':
        $('<span class="gift-plugin-text"><strong>AJÁNDÉK</strong> ' + giftPrice + ' Ft értékben<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
        case 'cs':
          $('<span class="gift-plugin-text"><strong>ZDARMA dárek</strong> v hodnotě' + giftPrice + ' Kč<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
        case 'ro':
          $('<span class="gift-plugin-text"><strong>CADOU GRATUIT</strong> în valoare de' + giftPrice + ' Lei<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
        case 'bg':
        $('<span class="gift-plugin-text"><strong>ZADARMO darček</strong> v hodnote ' + giftPrice + ' &euro;<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
        case 'hr':
        $('<span class="gift-plugin-text"><strong>BESPLATAN poklon</strong> u vrijednosti od ' + giftPrice + ' &euro;<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
        case 'sl':
        $('<span class="gift-plugin-text"><strong>BREZPLAČNO darilo</strong> v vrednosti ' + giftPrice + ' &euro;<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
        case 'uk':
        $('<span class="gift-plugin-text"><strong>ZADARMO darček</strong> v hodnote ' + giftPrice + ' &euro;<span>').insertAfter('i.xyDiscount__icon.icon-gift');
        break;
      }
    }
  }
}

// add notification that additional gifts need to be added to the cart - only first step in cart
// TODO neskôr možno skontrolovať či počet pohoviek = počtu vankúšov (cez gift mappings) a na základe toho vypísať banner uspesnosti 
// TODO pripadne priamo zmeniť počet
function addGiftWarningCart() {
  if (
    $('.in-kosik .cart-xyDiscount__banner').length ||
    $('.in-kosar .cart-xyDiscount__banner').length ||
    $('.in-cos-de-cumparaturi .cart-xyDiscount__banner').length ||
    $('.in-cart .cart-xyDiscount__banner').length
  ) {
    var text = '';
    switch (lang) {
      case 'sk': text = 'Chceš všetky darčeky? Pridaj do košíka toľko darčekov, koľko máš v ňom produktov s prislúbeným darčekom.'; break;
      case 'hu': text = 'Az összes ajándékot szeretnéd? Adj hozzá annyi ajándékot a kosaradhoz, amennyi terméket a megígért ajándékkal együtt már beleraktál.'; break;
      case 'cs': text = 'Chcete všechny dárky? Přidejte do košíku tolik dárků, kolik v něm máte produktů se slíbeným dárkem.'; break;
      case 'ro': text = 'Vrei toate cadourile? Adaugă în coș atât de multe cadouri câte produse cu cadou promise ai în coș.'; break;
      case 'bg': text = 'Vrei toate cadourile? Adaugă în coș atât de multe cadouri câte produse cu cadou promise ai în coș.'; break;
      case 'hr': text = 'Želiš li sve darove? Dodaj onoliko darova u košaricu koliko u njoj ima proizvoda s obećanim darom.'; break;
      case 'sl': text = 'Želite vsa darila? Dodajte toliko daril, kolikor izdelkov s pripadajočim darilom imate v košarici.'; break;
      case 'uk': text = 'Vrei toate cadourile? Adaugă în coș atât de multe cadouri câte produse cu cadou promise ai în coș.'; break;
    }

    $('tr.xy-discount-target').each(function () {
      var row = $(this);

      // odstráň banner z pôvodného miesta (ak tam je)
      row.find('.banner-warning-gift').remove();

      // odstráň náš wrapper riadok (ak už existuje)
      row.next('tr.gift-message-row').remove();

      var columnsCount = row.children('td,th').length || 1;

      row.after(
        '<tr class="gift-message-row">' +
          '<td colspan="' + columnsCount + '">' +
            '<div class="banner-warning-gift">' + text + '</div>' +
          '</td>' +
        '</tr>'
      );
    });
  }
}

